import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
// import FooterButton, { FooterButtonCenter } from '../../../components/FooterButton/FooterButton';
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
//PAGE
import P221List from "./P221List";
import P221Search from "./P221Search";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { P221GetDataList } from "../../../service/200/P221Service";
import { Dialog } from "primereact/dialog";

export default function P221({ dialog, setDialog, data }) {
    
    const history = useHistory();
    const toast = useRef(null);
    const [dataTable, setDataTable] = useState([]);
    const [loading, setLoading] = useState(false);

    // SEARCH
    const [searchData, setSearchData] = useState({
        contractNo: "",
        routeNo: 0,
        routeName : "",
        userId: dataUserSession() ? dataUserSession().userId : "",
    });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {

        setSearchData({
            ...searchData,
            contractNo: data.contractNo,
            routeNo: data.routeNo,
            routeName : data.routeName
        })
        
    }, [data]);

    useEffect(() => {
        onP221GetDataList();
    }, [searchData]);

    const onP221GetDataList = () => {
        setLoading(true);
        P221GetDataList(searchData).then(
            (res) => {
                setLoading(false);
                // console.log(res)
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                if (err.response && err.response.data.status === 401) {
                    alert(JSON.stringify("เนื่องจาก Authorized หมดอายุ กรุณาเข้าสู่ระบบใหม่"));
                    window.location.href = "/login";
                }
                setLoading(false);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Dialog 
                header="รายละเอียดการส่งงาน P1" 
                visible={dialog.dialog} 
                style={{ width: "50vw" }} 
                className="p-fluid ___widthDialog" 
                onHide={() => setDialog(false)} 
                blockScroll={true} 
                maximizable maximized 
            >
                <Loading loading={loading} />
                <div className="p-grid crud-demo">
                    <Toast ref={toast} position="top-right" />
                    <div className="p-col-12">
                        <div className="card">
                            <P221Search setDialog={setDialog} data={searchData} />
                            <P221List dataTable={dataTable} />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
